import { useAuth } from "../context/AuthContext";

/** Kleiner Komfort-Hook zur Rechteprüfung in Komponenten. */
export function usePermission(permission: string): boolean {
  const { hasPermission } = useAuth();
  return hasPermission(permission);
}

export function useAnyPermission(...permissions: string[]): boolean {
  const { hasPermission } = useAuth();
  return permissions.some((p) => hasPermission(p));
}
